const STACKED_LAYOUT_QUERY = '(width < 64rem)';

export const matchesStackedLayout = (): boolean => window.matchMedia(STACKED_LAYOUT_QUERY).matches;

export function subscribeToStackedLayout(onLayoutChange: () => void): () => void {
  const mediaQueryList = window.matchMedia(STACKED_LAYOUT_QUERY);
  mediaQueryList.addEventListener('change', onLayoutChange);
  return () => mediaQueryList.removeEventListener('change', onLayoutChange);
}
